import DatatablesController from '../../../datatables_controller';

export default class extends DatatablesController {
  datatableColumns(){
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 40,
        type: 'number',
        selector: false,
        textAlign: 'left',
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'user',
        title: 'Nama User',
        sortable: false,
        width: 100,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.user}</span>`;
        }
      },
      {
        field: 'resource',
        title: 'Brevet',
        sortable: false,
        width: 100,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.resource}</span>`;
        }
      },
      {
        field: 'resource_type',
        title: 'Tipe Rating',
        sortable: false,
        width: 100,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.resource_type}</span>`;
        }
      },
      {
        field: 'rating',
        title: 'Rating',
        sortable: false,
        width: 60,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.rating}</span>`;
        }
      },
      {
        title: 'Tanggal',
        field: 'Tanggal',
        sortable: false,
        width: 100,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.date}</span>`;
        }
      },
      {
        field: 'comment',
        title: 'Komentar',
        sortable: false,
        width: 300,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.comment}</span>`;
        }
      },
    ]
  }
}
